module.exports = __webpack_public_path__ + "images/568a1514efa5a2b261187d25dd4f41f033846bcaab91a5301930b505c8b61e29.svg";